<p-toast></p-toast>
<div class="content">
  <h3>Veículos</h3>
  <div class="lista-container" *ngIf="items && items.length > 0">
    <div class="selecionar-todos">
      <input
        type="checkbox"
        id="checkboxSelecionarTodos"
        (change)="selectAll()"
      />
      <label for="checkboxSelecionarTodos"></label>
      <label for="checkboxSelecionarTodos">Selecionar todos</label>
    </div>

    <div class="lista">
      <!-- Item 1 -->
      <div class="item" *ngFor="let item of items">
        <div class="info-container-left">
          <div>
            <input
              type="checkbox"
              [(ngModel)]="item.selected"
              class="custom-checkbox"
            />
          </div>
          <div class="linha-info">
            <span class="nome">Placa:</span>
            <span
              class="nrPlaca"
              (click)="abrirModalDeConsulta(item.oidCadastroVeiculos)"
              >{{ item.nrPlaca }}</span
            >
            <span class="nome">Modelo:</span>
            <span class="dsModelo">{{ item.dsModelo }}</span>
          </div>
        </div>

        <div class="icones">
          <div class="icone">
            <span
              class="pi pi-check-circle custom-icon icone-check"
              (click)="aprovarVeiculoSelecionada(item.oidCadastroVeiculos)"
            ></span>
          </div>
          <div class="icone">
            <span
              class="pi pi-times-circle custom-icon icone-times"
              (click)="removerVeiculoSelecionada(item.oidCadastroVeiculos)"
            ></span>
          </div>
          <div class="icone">
            <span
              class="pi pi-download custom-icon icone-download"
              (click)="baixarArquivos(item.oidCadastroVeiculos)"
            ></span>
          </div>
        </div>
      </div>
    </div>

    <div class="linha-acoes">
      <p-button
        label="Aprovar Selecionados"
        (onClick)="aprovarSelecionados()"
        styleClass="p-button-success custom-button"
        icon="pi pi-check-circle"
        iconPos="left"
      />

      <p-button
        label="Remover Selecionados"
        (onClick)="removerSelecionados()"
        styleClass="p-button-danger custom-button"
        icon="pi pi-times-circle"
        iconPos="left"
      />
    </div>
  </div>
  <div
    class="linha-msg"
    style="width: 100%"
    *ngIf="!items || items.length === 0"
  >
    <p class="success">Não existem veículos pendentes de aprovação</p>
  </div>
</div>

<app-dialog-veiculo
  [oidCadastroVeiculos]="oidCadastroVeiculosSelecionado"
  [displayDialog]="displayDialog"
  (closeDialog)="closeDialog()"
  *ngIf="displayDialog && oidCadastroVeiculosSelecionado"
></app-dialog-veiculo>

<app-dialog-motivo-reprovacao
  [inputData]="inputData"
  [displayDialog]="displayDialogMotivoReprovacao"
  (data)="onDialogMotivoClose($event)"
></app-dialog-motivo-reprovacao>
